// Static credentials untuk portfolio demo
// 3 Role: Admin Akademik, Admin Prodi, Dosen

export const DEMO_CREDENTIALS = [
    {
        user_name: "admin.akademik",
        user_password: "demo@akademik2024",
        role: "admin_akademik",
        level_id: 26,
        grub_id: 1,
        user_data: {
            usid: "ADM001",
            user_nama: "Dr. Ahmad Sudrajat, M.Kom",
            user_email: "admin.akademik@asia.ac.id",
            jabatan: "Kepala Bagian Akademik",
            foto: null
        }
    },
    {
        user_name: "admin.prodi",
        user_password: "demo@prodi2024",
        role: "admin_prodi",
        level_id: 26,
        grub_id: 2, // Prodi Teknik Informatika
        user_data: {
            usid: "APR001",
            user_nama: "Ir. Budi Santoso, M.T.",
            user_email: "admin.prodi@asia.ac.id",
            jabatan: "Kepala Program Studi Teknik Informatika",
            prodi_id: 1,
            prodi_nama: "Teknik Informatika",
            foto: null
        }
    },
    {
        user_name: "dosen",
        user_password: "demo@dosen2024",
        role: "dosen",
        level_id: 26,
        grub_id: 3,
        user_data: {
            usid: "DSN001",
            user_nama: "Dr. Citra Dewi, S.Kom., M.Cs.",
            user_email: "citra.dewi@asia.ac.id",
            nidn: "0712058901",
            jabatan: "Dosen Tetap",
            prodi_id: 1,
            prodi_nama: "Teknik Informatika",
            foto: null
        }
    }
];

// Helper function untuk validasi login
export const validateLogin = (username, password) => {
    const user = DEMO_CREDENTIALS.find(
        cred => cred.user_name === username && cred.user_password === password
    );

    if (user) {
        return {
            success: true,
            data: user
        };
    }

    return {
        success: false,
        message: "Username atau password salah!"
    };
};

// Helper function untuk mendapatkan user berdasarkan usid
export const getUserById = (usid) => {
    const user = DEMO_CREDENTIALS.find(cred => cred.user_data.usid === usid);
    return user || null;
};

// Role permissions untuk menentukan menu yang ditampilkan
export const ROLE_PERMISSIONS = {
    admin_akademik: {
        dashboard: true,
        setting_akademik: true,
        data_mahasiswa: true,
        data_dosen: true,
        olah_jadwal: true,
        evaluasi: true,
        rekap: true,
        all_prodi: true // bisa akses semua prodi
    },
    admin_prodi: {
        dashboard: true,
        setting_akademik: false,
        data_mahasiswa: true,
        data_dosen: true,
        olah_jadwal: true,
        evaluasi: true,
        rekap: true,
        all_prodi: false // hanya prodi sendiri
    },
    dosen: {
        dashboard: true,
        setting_akademik: false,
        data_mahasiswa: true, // view only, mahasiswa perwalian
        data_dosen: false,
        olah_jadwal: false,
        jadwal_mengajar: true,
        input_nilai: true,
        presensi: true,
        evaluasi: false,
        rekap: false,
        all_prodi: false
    }
};

export default DEMO_CREDENTIALS;
